import { motion, useReducedMotion } from "framer-motion";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface HoverLiftProps {
  children: ReactNode;
  className?: string;
  /** Disable the lift transform but keep the shadow ramp. */
  disabled?: boolean;
}

/**
 * Adds a subtle hover-lift + tap-press affordance to clickable cards.
 * Reduced-motion users only see the shadow ramp.
 */
export function HoverLift({ children, className, disabled }: HoverLiftProps) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={cn("transition-shadow duration-200 hover:shadow-lg", className)}
      whileHover={reduce || disabled ? undefined : { y: -2 }}
      whileTap={reduce || disabled ? undefined : { scale: 0.99 }}
      transition={{ duration: 0.18, ease: [0.2, 0.8, 0.2, 1] }}
    >
      {children}
    </motion.div>
  );
}